// extracted by mini-css-extract-plugin
export default {"Star":"Star_Star__5xnVH","Star_Active":"Star_Star_Active__4nCqV"};